var React = require('react');

function BackIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.02348 15.6933C8.23875 15.8918 8.51272 16 8.83562 16C9.48141 16 10 15.531 10 14.9357C10 14.6381 9.86301 14.3675 9.63796 14.1601L2.78865 7.99098L9.63796 1.83991C9.86301 1.63247 10 1.35287 10 1.06426C10 0.468997 9.48141 0 8.83562 0C8.51272 0 8.23875 0.10823 8.02348 0.306652L0.410959 7.16122C0.136986 7.39572 0.00978474 7.68433 0 8C0 8.31567 0.136986 8.58625 0.410959 8.82976L8.02348 15.6933Z","fill":"#EB4D3D"}));
}

BackIconInline.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = BackIconInline;

BackIconInline.default = BackIconInline;
